<template>
	<div class="text-left">
		<div id="help_menu">
			<router-link
				v-for="(item, index) in menu"
				:to="{ name: item.slug }"
				v-bind:key="'help_menu_' + index"
			>
				<div
					class="help_menu_element"
					v-bind:class="{
						'active-bg': $route.name == item.slug ? true : false
					}"
				>
					<span>
						{{ item.label }}
					</span>
				</div>
			</router-link>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			menu: [
				{
					slug: "help-and-support-introduction",
					label: "Introduction"
				},
				{
					slug: "help-and-support-key-features",
					label: "Getting started"
				},
				{
					slug: "help-and-support-user-guide",
					label: "User guide"
				},
				{
					slug: "help-and-support-methodology",
					label: "Methodology"
				},
				{
					slug: "help-and-support-faq",
					label: "Frequently asked questions"
				},
				{
					slug: "help-and-support-further-resources",
					label: "Further resources"
				},
				{
					slug: "help-and-support-terms-of-use",
					label: "Terms of use"
				},
				{
					slug: "release-notes",
					label: "Release notes"
				}
			]
		};
	}
};
</script>

<style>
#help_menu {
	margin-top: 50px;
	color: white;
}
.help_menu_element {
	width: 100%;
	height: 60px;
	line-height: 60px;
	cursor: pointer;
}
.help_menu_element.active {
	font-weight: bold;
	background-color: var(--primary3);
}

.help_menu_element > span {
	padding-left: 30px;
}
.help-support {
	max-width: 800px;
	margin: 40px auto 0;
	color: white;
}
.help-support-title {
	font-size: 24px;
	font-weight: bold;
}
.help-support-text p {
	line-height: 24px;
	font-size: 16px;
	margin-bottom: 30px;
	font-weight: 500;
}
.help-support-text li {
	padding: 3px 0;
	font-size: 16px;
	font-weight: 500;
	line-height: 24px;
}
.help-support-text img {
	width: 90%;
	margin-left: 5%;
}
.help-support-text a {
	color: var(--active);
}
.help-support-text table {
	border-collapse: collapse;
	border: 1px solid white;
	width: 100%;
}
.help-support-text td {
	border: 1px solid white;
}
.help-support-text tr {
	line-height: 40px;
}
</style>
